'use client';
import { FC, ReactNode, useEffect, useState } from 'react';
import Text from '../Text';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { twMerge } from 'tailwind-merge';

type ClassNamesTypes = {
  wrapper?: string;
  btn?: string;
  svg?: string;
  message?: string;
};

type ShareButtonPropTypes = {
  classNames?: ClassNamesTypes;
  message: string;
  children: ReactNode;
  hideTooltip?: boolean;
};

const Tooltip: FC<ShareButtonPropTypes> = ({
  message,
  classNames,
  children,
  hideTooltip,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Close the popover on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsOpen(false);
    };
    if (isOpen) {
      window.addEventListener('scroll', handleScroll);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isOpen]);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        onMouseEnter={() => setIsOpen(true)}
        onTouchStart={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}>
        {children}
      </PopoverTrigger>
      {!hideTooltip && (
        <PopoverContent
          side='top'
          className='rounded-md border border-black/10 bg-black text-white px-1 py-2 lg:max-w-2xl m-3 z-30'>
          <Text className={twMerge('text-left text-sm', classNames?.message)}>
            {message}
          </Text>
        </PopoverContent>
      )}
    </Popover>
  );
};

export default Tooltip;
